import { Paper, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import ActionButton from '../../../components/ActionButton';
import { STRINGS } from '../../../constants';
import { INSURANCE_SECTION } from '../../Order/constants';
import configSlice from '../../../redux/configSlice';

export function CitysprintExtendedCoverSection() {
  const sameDayInsurance = useSelector(
    state => configSlice.selectors.getConfig(state).common?.sameDayInsurance
  );

  const [coverValue, coverCost] =
    Object.entries(sameDayInsurance ?? {})[0] ?? [];

  return (
    <>
      {sameDayInsurance && coverValue && (
        <Paper
          component='section'
          elevation={0}
          sx={{
            mt: 2,
            p: { xs: 1.5, sm: 2 },
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: '0px 1px 3px rgba(0,0,0,0.08)',
            bgcolor: 'background.paper',
          }}
          aria-labelledby='citysprint-extended-cover-title'
        >
          <Typography
            id='citysprint-extended-cover-title'
            variant='h5'
            component='h2'
            sx={{
              mb: 2,
              color: 'text.primary',
              fontSize: { xs: '1.125rem', sm: '1.25rem' },
              letterSpacing: 0,
            }}
          >
            {STRINGS.LIABILITY_COVER_FOR_YOUR_PARCEL}
          </Typography>
          <ActionButton
            id='citysprint-extended-cover'
            selected
            title={INSURANCE_SECTION.TITLE(coverValue)}
            bodyText={INSURANCE_SECTION.DESCRIPTION(
              Number(coverValue),
              coverCost
            )}
            price={INSURANCE_SECTION.PRICE(coverCost)}
            cardOnclick={() => {}}
          />
        </Paper>
      )}
    </>
  );
}
